<template>
    <div style="width: 100%">
        <bee-datatable
            :fixed-header="fixedHeader && (on_mdAndUp || height)"
            :max-height="height"
            :hide-header="hideHeader"
            :hide-footer="hideFooter"
            :headers="localHeaders"
            :items="items"
            :addable="false"
            :zebra="zebra"
            :clickable="clickable"
            :loadingData="loadingData"
            @contextmenu="openContextMenu"
            @dblclick:row="(e, i) => $emit('dblclick:row', e, i)"
            :is-funds="false"
            :highlighted-color="highlightedColor"
            :highlighted-expression="highlightedExpression">
            <template v-for="header in localHeaders" v-slot:[`item.${header.value}`]="{ item }">
                <slot :name="`item.${header.value}`" :item="item"></slot>
                <v-tooltip :key="header.value" top>
                    <template v-slot:activator="{ }">
                        <div v-if="header.type == 'string'"> 
                            <bee-text-field :readonly="true"
                            :context="context" 
                            :action-name="actionName"
                            class="input-text-center"  :showOnlyNumbersPatch="showOnlyNumbersPatch"
                            :inside-table="true" :value="getValueFromObject(item, header.value, true)"
                            :multi-line="true" :empty-state="empty(header)"></bee-text-field>
                        </div>
                        <div v-if="header.type == 'auto_increment'"> {{ items.indexOf(item) + 1 }} </div>
                        <div v-if="header.type == 'date'"> 
                            <bee-date-field  :value="getValueFromObject(item, header.value)"
                                :readonly="true" :empty-state="empty(header)"
                                :inside-table="true"
                            ></bee-date-field>
                        </div>
                        <div v-if="header.type == 'quantity'"> 
                            <bee-quantity-label 
                                :value="getValueFromObject(item, header.value)"
                                :empty-state="empty(header)"
                            ></bee-quantity-label>
                        </div>
                        <div v-if="header.type == 'money'" style="font-size:16px !important">
                            <bee-money-label  v-if="getValueFromObject(item, header.value) ? getValueFromObject(item, header.value).money_type >=0 ? false : true : true" 
                                :readonly="true" 
                                class="input-text-center" :inside-table="true"   :with-color="withColor"
                                :number="getValueFromObject(item, header.value)? getValueFromObject(item, header.value).amount : null"  :empty-state="empty(header)"
                                :type="getValueFromObject(item, header.value) ? (getValueFromObject(item, header.value).money_type >=0 ? (getValueFromObject(item, header.value).money_type == 1 ? 'debit' : 'credit') : null) :null" 
                            ></bee-money-label>
                            <bee-advanced-money-label v-else :empty-state="empty(header)" :value="getValueFromObject(item, header.value)" :with-color="true" :currencies="configs.currencies"></bee-advanced-money-label>
                        </div>
                        <div v-if="header.type == 'numeric'">
                            <bee-money-label  v-if="getValueFromObject(item, header.value) ? getValueFromObject(item, header.value).money_type >=0 ? false : true : true"
                                :readonly="true" 
                                class="input-text-center" :inside-table="true"   :with-color="withColor"
                                :number="getValueFromObject(item, header.value)" :empty-state="empty(header)"
                            ></bee-money-label>
                        </div>
                        <div v-if="header.type == 'select'" class="justify-start">
                            <bee-currencies-autocomplete 
                            @change="$emit('equivalent-currency-id-changed', $event)" 
                            :value="getValueFromObject(item, header.value)"  
                            :items="configs.currencies" 
                            :inside-table="true" item-text="symbol"
                            ></bee-currencies-autocomplete>
                        </div>
                        <div v-if="header.type == 'multi-select'" class="justify-start">
                            <bee-multi-select :context="context" :action-name="actionName" :empty-state="empty(header)" :inside-table="true" :readonly="true" :value="getValueFromObject(item, header.value)"  :items="configs.accounts"  item-text="name"></bee-multi-select>
                        </div>
                        <div v-if="header.type == 'accounts-autocomplete'" style="justify-start">
                                <bee-account-autocomplete
                                :context="context" 
                                :action-name="actionName" 
                                :value="getValueFromObject(item, header.value)"  :items="configs.accounts || []"
                                :readonly="true" :inside-table="true"  :empty-state="empty(header)"
                                :item-text="header.settings.itemText" style="width: 100%;" ></bee-account-autocomplete>
                        </div>
                        <div v-if="header.type == 'currencies-autocomplete'">
                            <bee-currencies-autocomplete  
                                :empty-state="empty(header)"
                                :item-text="header.settings.itemText" 
                                :items="configs.currencies || []"
                                :inside-table="true" :readonly="true"  :value="getValueFromObject(item, header.value)"
                            ></bee-currencies-autocomplete>
                        </div>
                        <div v-if="header.type == 'autocomplete'">
                            <bee-autocomplete  
                                :context="context" 
                                :action-name="actionName"
                                :empty-state="empty(header)"
                                :item-text="header.settings.itemText" 
                                :item-value="header.settings.itemValue" 
                                :items="header.settings.items || []"
                                :inside-table="true" :readonly="true"  :value="getValueFromObject(item, header.value)"
                            ></bee-autocomplete>
                        </div>
                        <v-flex v-if="header.type == 'actions'" offset-y class="d-inline px-1">
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'change-status').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('change-status')" @click="$emit('change-status', item)" type="change-status"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'show').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('show')" @click="$emit('show', item)" type="show"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'show-file').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('show-file')" @click="$emit('show-file', item)" type="show-file"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'enter').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('enter')" @click="$emit('enter', item)" type="enter"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'edit').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('edit')" @click="$emit('edit', item)" type="edit"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'equivalent_price').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('equivalent_price')" @click="$emit('equivalent', item)" type="cached"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'history').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('history')" @click="$emit('history', item)" type="history"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'delete').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('delete')" @click="$emit('delete', item)" type="delete"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'statement').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('statement')" @click="$emit('statement', item)" type="statement"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'folder').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('folder')" @click="$emit('folder', item)" type="folder"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'settings').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('settings')" @click="$emit('settings', item)" type="settings"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'inventory').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('inventory')" @click="$emit('inventory', item)" type="inventory"></bee-btn>
                            <bee-btn :context="context" :action-name="header.actions.find(c=>c.name == 'upload').action_name" beeicon outer-class="mr-1" v-if="header.actions.map(c=>c.name).includes('upload')" @click="$emit('upload', item)" type="upload" icon-color="black"></bee-btn>
                        </v-flex>
                    </template>
                    <span> {{ getValueFromObject(item, header.value) }} </span>
                </v-tooltip>
            </template>
        </bee-datatable>
         <v-menu
                v-model="menu"
                :position-x="mouse.x"
                :position-y="mouse.y"
                absolute
                offset-y>
                <bee-list v-if="showMenuActions">
                    <div v-for="(item, i) in rightClickMenuItems" :key="i">
                        <bee-list-item :item="item.name == 'matching' && rightClickItem ? {...item, text: rightClickItem.is_matched ? $t('cancel-matching') :  $t('match') } : item" :context="context" @click="$emit(`${item.name}`, rightClickItem)">
                        </bee-list-item>
                    </div>
                </bee-list>
            </v-menu>
    </div>
</template>

<script>
export default {
    props: ['items', 'headers', 'empty-state', 'hide-header', 'hide-footer', 'with-color', 'configs', 'zebra',  'show-menu-actions', 'right-click-menu-items','showOnlyNumbersPatch','highlighted-color','highlighted-expression', 'context', 'actionName', 'fixed-header', 'clickable', 'height'],
    data: () => ({
        menu: false,
        mouse: {x: 0, y: 0},
        rightClickItem:null,
        loadingData:false,
        emptyStrings: [{
            string: '_',
            type: 'dashes'
        }, {
            string: '',
            type: 'none'
        }],
        itemFocused: {
            index: null,
            value: null,
            header: {
                value: null
            }
        }
    }),
    computed: {
        localHeaders:{
            get: function() { 
                return this.headers.map(header => { return {...header, align: 'center', cellClass: 'dynamic-width dynamic-width-' + header.width} })
            },
            set: function(value){
                this.headers = value
            }
        },
        on_mdAndUp(){
            if(this.$vuetify.breakpoint.mdAndUp)
                return true
            return false;
        }
    },
    methods: {
        empty(header) {
            let type =  header.settings ? (header.settings.emptyState ? header.settings.emptyState : this.emptyState): this.emptyState
            return this.emptyStrings.find(es => es.type == type).string
        },
        openLoading()
        {
            this.loadingData=true
        },
        closeLoading(){
            this.loadingData=false
        },
         openContextMenu(e, item) {
            this.rightClickItem = item.item
            e.preventDefault()
            this.menu = false
            this.mouse.x = e.clientX
            this.mouse.y = e.clientY
            this.$nextTick(() => {
                this.menu = true
            })
        },
        getValueFromObject(object, header, isFirst = false) {
            if(header == '') return isFirst ? '' : object
            let path = (header|| "").split('.')
            object = object[path[0].trim()]
            path.shift()
            return( object && typeof object === 'object' && object.constructor === Object) ? this.getValueFromObject(object, path.join('.')) : object 
        },
        onEnter(index) {
            if(index == this.items.length - 1)
                this.$emit('newrow')
        },
        onFocus(value) {
            if(this.itemFocused.value) this.$emit('cell-change', this.itemFocused)
            if(value.value) this.itemFocused = value
        },
    },

    i18n: {
        messages:{
            ar: {
                'match': 'مُطابقة',
                'cancel-matching': 'إلغاء المُطابقة',
            },
            en: {
                'match': 'Reconciliation',
                'cancel-matching': 'Cancel account reconciliation',
            },
            es: {
                'match': 'Reconciliación',
                'cancel-matching': 'Cancelar reconciliación de cuenta',
            },
        }
    }
}
</script>
<style scoped>
</style>